import { useState } from "react";
import { Formik, Form, FastField } from "formik";
import Button from "@mui/material/Button";
import { TextField } from "formik-material-ui";
import Typography from "@mui/material/Typography";
import * as Yup from "yup";

import PasswordValidation from "../PasswordValidation";
import useStyles from "./Styles";
import useButtonStyles from "../../styles/Buttons";
import { Box, InputLabel } from "@mui/material";
import useSharedStyles from "../../styles/Shared";

type Props = {
  onSubmit: (values: UserPasswordChangeVars, formikBag: unknown) => void | Promise<unknown>;
};

const ChangePassword: React.FC<Props> = ({ onSubmit }) => {
  const { classes } = useStyles();
  const { classes: buttonClasses, cx } = useButtonStyles();
  const { classes: sharedClasses } = useSharedStyles();
  const [password, setPassword] = useState("");

  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required("Current password is required"),
    password: Yup.string().required("Please enter new password"),
    confirmPassword: Yup.string()
      .required("Please confirm your new password")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  return (
    <Box className={sharedClasses.borderedBox} sx={{ bgcolor: "#fff" }}>
      <Typography variant="h3">Change Password</Typography>
      <Formik<UserPasswordChangeVars>
        validationSchema={validationSchema}
        initialValues={{ password: "", currentPassword: "", confirmPassword: "" }}
        onSubmit={onSubmit}
      >
        {() => (
          <Form>
            <div>
              <div className={sharedClasses.fieldBox}>
                <InputLabel>Current password</InputLabel>
                <FastField
                  name="currentPassword"
                  component={TextField}
                  placeholder="Current password"
                  type="password"
                  fullWidth
                  variant="outlined"
                />
              </div>
              <div className={sharedClasses.fieldBox}>
                <InputLabel>New password</InputLabel>
                <FastField
                  name="password"
                  component={TextField}
                  placeholder="New password"
                  type="password"
                  fullWidth
                  variant="outlined"
                  onKeyUp={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setPassword(e.target.value)
                  }
                />
                <PasswordValidation password={password} />
              </div>
              <div className={sharedClasses.fieldBox}>
                <InputLabel>Confirm password</InputLabel>
                <FastField
                  name="confirmPassword"
                  component={TextField}
                  placeholder="Confirm password"
                  type="password"
                  fullWidth
                  variant="outlined"
                />
              </div>
            </div>
            <Box sx={{ color: "#67676C", mb: 2, mt: 1, fontWeight: 400, fontSize: 14 }}>
              <div>Password requirements:</div>
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>At least 10 characters and up to 100 characters</li>
                <li>At least one lowercase character</li>
                <li>Password must include at least one uppercase character</li>
              </ul>
            </Box>
            <Button
              sx={{ mb: 2 }}
              type="submit"
              className={cx(buttonClasses.blue, buttonClasses.iconButton)}
            >
              Change Password
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ChangePassword;
